import React,{Component} from "react";
import {BrowserRouter as Router, Switch, Route, Link, Redirect} from "react-router-dom";

class Header extends React.Component{
    render(){
        return(
            <div>
                <header id="header-container"> 
                    {/*<!-- Header -->*/}
                    <div id="header">
                      <div className="container"> 
                        {/*<!-- Left Side Content -->*/}
                        <div className="left-side"> 
                          <div id="logo"> <Link to="/" ><img src="assets/images/logo.png" alt=""/></Link> </div>
                          <div className="mmenu-trigger">
                            <button className="hamburger hamburger--collapse" type="button"> <span className="hamburger-box"> <span className="hamburger-inner"></span> </span> </button>
                          </div>
                          {/*<!-- Main Navigation -->*/}
                          <nav id="navigation" className="style-1">
                            <ul id="responsive">
                			  <li><Link to="/" className={this.props.home}>Home</Link></li>
                        
                			  <li><a href="#">Sell</a>
                			   <ul>
                				<li><Link to="/about" >How to Sell with RISEE</Link></li>
                				<li className=""><Link to="/about" >Sellers Toolkit</Link></li>
                				<li><Link to="/about" >List your Home</Link></li>
                				<li><Link to="/about" >Sellers FAQ's</Link></li>
                			   </ul>
                			  </li>
                			  <li><a href="#">Buy</a>
                			  <ul>
                				<li><Link to="/about" >How to Buy with RISEE</Link></li>
                				<li className=""><Link to="/about" >Find Home</Link></li>
                				<li><Link to="/about" >Buyer's FAQ's</Link></li>
                			  </ul>
                			  </li>
                        <li> <Link to="/listings" className={this.props.listings} >Listings</Link> </li>
                			  {/*<!-- <li><a href="index.html">Sell</a>
                				<li><a href="index.html">How to Sell with RISEE</a></li>
                				<li className="active"><a href="index-2.html">Sellers Toolkit</a></li>
                				<li><a href="index-3.html">List your Home</a></li>
                				<li><a href="index-4.html">Sellers FAQ's</a></li>
                			  </ul>
                			  </li> -->*/}
                			  {/*<!-- <li><a href="index.html">Buy</a>
                				<li><a href="index.html">Home to Buy with RISEE</a></li>
                				<li className="active"><a href="index-2.html">Find Home</a></li>
                				<li><a href="index-3.html">Buyer's FAQ's</a></li>
                			  </ul>
                			  </li> -->*/}
                                {/*<!-- <ul>
                                  <li><a href="index.html">Home Version One</a></li>
                                  <li className="active"><a href="index-2.html">Home Version Two</a></li>
                                  <li><a href="index-3.html">Home Version Three</a></li>
                                  <li><a href="index-4.html">Home Version Four</a></li>
                                </ul> -->*/}
                              {/*  
                              <li><a href="#">Listings</a>
                                <ul>
                                  <li><a href="#">Listing Layout</a>
                                    <ul>
                                      <li><a href="listings-list-with-sidebar.html">Listing List With Sidebar</a></li>
                                      <li><a href="listings-list-with-map.html">Listing List With Map</a></li>
                					  <li><a href="listings-grid-compact-with-sidebar.html">Listing Compact Sidebar</a></li>
                                    </ul>
                                  </li>
                                  <li><a href="#">Listing Half Map</a>
                                    <ul>
                                      <li><a href="listings-half-map-list.html">Listing List Map</a></li>
                                      <li><a href="listings-half-map-grid-compact.html">Listing Compact Grid Map</a></li>
                                    </ul>
                                  </li>
                				  <li><a href="#">Single Property</a>
                                    <ul>
                                      <li><a href="single-property-page-1.html">Property Detail One</a></li>
                                      <li><a href="single-property-page-2.html">Property Detail Two</a></li>                      
                                    </ul>
                                  </li>                  
                                </ul>
                              </li>
                              {/*<!-- <li><a href="#">User Panel</a>
                				<ul>
                				  <li><a href="my-profile.html">User Profile</a></li>
                				  <li><a href="my-bookmarks.html">Bookmark Listing</a></li>
                				  <li><a href="my-properties.html">My Property</a></li>
                				  <li><a href="add-new-property.html">Add New Property</a></li>
                				  <li><a href="change-password.html">Change Password</a></li>
                				</ul>
                			  </li> -->*/}
                        
                         <li><a href="#">Pages</a>
                                <ul>
                				  <li><a href="#">Agents</a>
                                    <ul>
                                      <li><Link to="/agents" className={this.props.agents} >Agents List</Link></li>
                                      <li><a href="agents-profile.html">Agents Profile</a></li>
                                    </ul>
                                  </li>
                				  <li><a href="#">Agency</a>
                                    <ul>
                                      <li><Link to="/agency" className={this.props.agency} >Agency List</Link></li>
                                      <li><a href="agency-profile.html">Agency Profile</a></li>                      
                                    </ul>
                                  </li>
                				  <li><Link to="/about" className={this.props.about} >About</Link></li>
                				  <li><a href="login.html">Login</a></li>
                				  <li><a href="register.html">Register</a></li>
                                  <li><a href="pricing-tables.html">Pricing Plan</a></li>
                                  <li><a href="typography.html">Typography</a></li>
                				  <li><a href="compare-properties.html">Compare Properties</a></li>
                				  <li><a href="user_elements.html">User Elements</a></li>
                                  <li><a href="icon_cheatsheet.html">Icons Cheatsheet</a></li>
                                </ul>
                              </li>
                			  {/*<!-- <li><a href="#">Blog</a>
                                <ul>
                				  <li><a href="blog_list_right_sidebar.html">Blog List Right Sidebar</a></li>
                				  <li><a href="blog_list_left_sidebar.html">Blog List Left Sidebar</a></li>
                				  <li><a href="blog_detail_right_sidebar.html">Blog Detail Right Sidebar</a></li>
                				  <li><a href="blog_detail_left_sidebar.html">Blog Detail Left Sidebar</a></li>
                				</ul>
                              </li> -->*/}       
                        {/* 
                        <li> <Link to="/agents" className={this.props.agents} >Agents</Link> </li>
                        <li> <Link to="/agency" className={this.props.agency} >Agency</Link> </li>     
                        <li> <Link to="/about" className={this.props.about} >About</Link> </li>
                        */}
                			  <li> <Link to="/contact" className={this.props.contact} >Contact</Link> </li>
                            </ul>
                          </nav>
                          <div className="clearfix"></div>
                        </div>
                        {/*<!-- Left Side Content / End -->*/} 
                        
                        {/*<!-- Right Side Content / End -->*/}
                        <div className="right-side"> 
                          <div className="header-widget"> 
                			<Link to="/login" className="popup-with-zoom-anim log-in-button sign-in"><i className="icon-line-awesome-user"></i> <span>Sign In</span></Link> 
                		  {/*<a href="add-new-property.html" className="button border"><i className="icon-feather-plus-circle"></i> <span>Create Property</span></a> */}
                		  <Link to="/add_property" className="button border"><i className="icon-feather-plus-circle"></i><span>Create Property</span></Link> 
                      </div>
                        </div>
                        {/*<!-- Right Side Content / End -->*/} 
                      </div>
                    </div>
                    {/*<!-- Header / End -->*/} 
                  </header>
                  <div className="clearfix"></div>
            </div>
        )
    }
}

export default Header;